import { Outlet } from '@tanstack/react-router';

import { InitSip } from '@/routes/arc/widgets/arc-background-task/initializer/InitSip.tsx';

export const Route = createFileRoute({
  component: SIPLayout,
});

function SIPLayout() {
  return (
    <>
      <InitSip />
      <Outlet />
    </>
  );
}
